module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-toolbar', {
    attrs: {
      "color": "primary",
      "dark": "",
      "dense": "",
      "fixed": "",
      "clipped-left": "",
      "app": ""
    }
  }, [_c('logo', {
    on: {
      "toggle-drawer": function($event) {
        _vm.$emit('toggle-drawer')
      }
    }
  }), _vm._v(" "), _c('v-flex', {
    staticClass: "hidden-md-and-down"
  }, [_c('search-lg')], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    staticClass: "hidden-md-and-down f",
    attrs: {
      "shrink": ""
    }
  }, [(_vm.$auth.isAuthenticated()) ? _c('menu-profile') : _c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": _vm.demoGetToken
    }
  }, [_vm._v("\n            Demo login\n        ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d5d4f51a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TheHeader/TheHeader.vue
// module id = 401
// module chunks = 0